import request from "@/utils/request";

// 科目
export function getUnionAccountListFun(data) {
  return request({
    url: `/fmsapi/Voucher/GetUnionAccountList`,
    method: "post",
    data,
  });
}
// 科目
export function updAccountRecordFun(data) {
  return request({
    url: `/fmsapi/Voucher/UpdAccountRecord`,
    method: "post",
    data,
  });
}
